const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const getCommercialWorkOrderList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_COM_WORK_ORDER_LIST':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_COM_WORK_ORDER_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getCommercialWorkOrderList;
  